import dayjs from '@/common/config/dayjs'

import { defaultReveniDisplayName, maxRelativeDays, minRelativeDays } from './constants'

export const getDayLabel = (dateString, t, language) => {
  if (!dateString) return ''
  const date = dayjs(dateString)
  const now = dayjs()

  if (date.isSame(now, 'day')) {
    return t('HOY')
  }

  if (date.isSame(now.subtract(1, 'day'), 'day')) {
    return t('AYER')
  }

  const diffDays = now.startOf('day').diff(date.startOf('day'), 'day')
  if (diffDays >= minRelativeDays && diffDays <= maxRelativeDays) {
    return t('HACE {{days}} DÍAS', { days: diffDays })
  }

  return date.locale(language).format('ddd D MMM YYYY').toUpperCase()
}

export const formatTime = dateString => {
  if (!dateString) return ''
  return dayjs(dateString).format('HH:mm')
}

export const groupEventsByDay = (events, t, language) => {
  const groups = []
  let currentLabel = null
  let currentEvents = []

  events.forEach(event => {
    const label = getDayLabel(event.timestamp, t, language)
    if (label !== currentLabel) {
      if (currentLabel !== null) {
        groups.push({ label: currentLabel, events: currentEvents })
      }
      currentLabel = label
      currentEvents = [event]
    } else {
      currentEvents.push(event)
    }
  })

  if (currentLabel !== null) {
    groups.push({ label: currentLabel, events: currentEvents })
  }

  return groups
}

export const getUserDisplayName = user => {
  if (!user) return ''
  if (user.is_reveni_user) {
    return user.display_name || defaultReveniDisplayName
  }
  return user.display_name || user.username || ''
}
